import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-base-card',
    templateUrl: './base-card.component.html',
    styleUrls: ['./base-card.component.scss'],
    standalone: false
})
export class BaseCardComponent {
  @Input() cardTitle!: string | null;
  @Input() contentClasses!: string | string[] | null;
  @Input() cardIcon!: string | null;
}
